import { useRef } from "react";
import { AppBar, Toolbar, Typography } from "@mui/material";

import { Box } from "@mui/system";

import { INGAppBarProps } from "../../library/NGFieldExtensions";
import NGVisibleMenu from "../NGVisibleMenu/NGVisibleMenu";
import { useSignal } from "@preact/signals-react";
import { Link } from "react-router-dom";
import { setupLocalState } from "../../library/dataService";
import { getsxObject } from "../../library/utils";
import NGImage from "../NGImage/NGImage";
import { GetSettingFromSite } from "../../library/dataService";

export default function NGAppBar({ config, context, menu }: INGAppBarProps) {
  const local = setupLocalState(
    config,
    {
      Style: useSignal(config.Style ?? {}),
    },
    context
  );
  const appBarRef = useRef<HTMLHeadingElement>(null);

  const logo = GetSettingFromSite("Logo");

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          width: config.Width,
          height: config.Height,
          marginLeft: config.MarginLeft,
          marginRight: config.MarginRight,
          marginTop: config.MarginTop,
          marginBottom: config.MarginBottom,
        }}
        variant={config.Variant as any}
        ref={appBarRef}
      >
        <Toolbar sx={getsxObject(local.Style.value)}>
          <Link to="/" target={config.LogoLinkTarget ?? undefined}>
            {config.LogoLink || logo ? (
              <NGImage
                config={{
                  Id: "mofqksmmbh",
                  __typename: "Image",
                  Value: config.LogoLink || logo,
                  Style: { height: config.LogoHeight ?? "22px", width: config.LogoWidth ?? "auto" },
                  AlternativeText: config.LogoAltText,
                  Classes: GetSettingFromSite("LogoClassName"),
                }}
                context={context}
              />
            ) : (
              null
              // <img src={jbiLogo} alt="SVG description" />
            )}
          </Link>
          <Typography variant="h6" sx={{ flexGrow: 1 }}></Typography>

          <Box>{menu && <NGVisibleMenu config={{ Data: menu }} context={context} />}</Box>
        </Toolbar>
      </AppBar>
    </>
  );
}
